import React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { I18nProvider } from './hooks/useI18n';
import { AppAppearanceProvider } from './theme/AppAppearanceContext';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <I18nProvider>
    <AppAppearanceProvider>
      <CssBaseline />
      <App />
    </AppAppearanceProvider>
  </I18nProvider>
);
